import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      " What sets TekRevol apart as a mobile app development company in Atlanta?",
    answer: `<p>TekRevol stands out for its proven track record of delivering feature-rich, cutting-edge mobile applications. We prioritize seamless navigation, usability, and quick delivery to ensure an incredible experience for the users. Our expert Atlanta app developers use the latest technologies to create personalized solutions for businesses worldwide</p>`,
  },
  {
    question: "Is app development in high demand in Atlanta?",
    answer: ` <p>The demand for app development in Atlanta is growing by the day and every other business is considering this solution to stay competitive in the market. Different businesses are looking for reliable applications as per their requirements. Atlanta has been already recognized as the tech hub in Georgia and this is high time for any business here to deploy mobile app development.</p>`,
  },
  {
    question: " How do I find developers to make an app in Atlanta?",
    answer: ` <p>If you are looking for professional mobile app developers in Atlanta, you can consult with us. TekRevol has an experienced team of developers that has already facilitated multiple businesses with full-fledged mobile app solutions.</p>
        <p>It is a great opportunity for your business to mark your online presence with the powerful influence of having credible mobile app solutions.</p>`,
  },
  {
    question: "How much does it cost to develop a mobile app in Atlanta?",
    answer: `<p>The cost of mobile app development in Atlanta may vary according to the requirements and scope of the projects. However, the price range varies from $80k-$250k. There are different types of mobile app solutions that you can have and the budget may vary according to them between the given range:</p>
        <ul>
        <li>Native apps</li>
        <li>Cross-platform apps</li>
        <li>Hybrid apps</li>
    </ul>`,
  },
  {
    question: " How long does Tekrevol take to develop an App in Atlanta?",
    answer: `<p>The duration of app development in Atlanta usually varies according to the scale of the business and operations. These are factors on which the structure and requirements of the application depend. Meanwhile, the average time frame for the development of a mobile app is between 4-6 months.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
